// Core
import { List } from 'immutable';
import { handleActions } from 'redux-actions';

// Instruments
import { compareActions as actions } from 'bus/compare/actions';

const initalState = List();

export const compareReducer = handleActions({
    [actions.loadLocalComparedSuccess]: (state, { payload: compared }) => {
        return state.clear().merge(compared);
    },
    [actions.addToCompare]: (state, { payload: { hotelId, offerId }}) => {
        return !state.some((compared) => compared.offerId === offerId && compared.hotelId === hotelId)
            && state.push({
                hotelId,
                offerId,
            });
    },
    [actions.removeFromCompare]: (state, { payload: offerId }) => {
        return state.filter((compared) => compared.offerId !== offerId);
    },
}, initalState);
